import { render, staticRenderFns } from "./merchant-square.vue?vue&type=template&id=c22b1382&scoped=true"
import script from "./merchant-square.vue?vue&type=script&lang=js"
export * from "./merchant-square.vue?vue&type=script&lang=js"
import style0 from "./merchant-square.vue?vue&type=style&index=0&id=c22b1382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22b1382",
  null
  
)

export default component.exports